import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { Button, useToast } from '@morressier/alembic';
import { useNavigate, useParams } from 'react-router-dom';
import { useForgetPasswordMutation } from 'src/api/signUpMutation';
import EmptyState from 'src/components/Submission/BoardMemberReviewsTab/EmptyState';
import { BrandLogo } from '../SignUpInviteSent';


const PasswordResetInviteSent = () => {
  const { email } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const forgetPasswordMutation = useForgetPasswordMutation();

  const handleResendEmail = async () => {
    const res = await forgetPasswordMutation.mutateAsync({
      email: email || ''
    });

    if (!res.isSuccess) {
      toast({
        variant: 'error',
        title: 'Error',
        description: res?.message?.message
          ? res?.message?.message
          : res?.message?.error
          ? res?.message?.error
          : 'Internal Server Error',
        isClosable: true
      });
    } else {
      toast({
        variant: 'success',
        title: 'Success',
        description: 'Password reset link sent',
        isClosable: true
      });
    }
  };

  return (
    <Flex flexDirection="column" gap={3} width={'80%'} marginX={'auto'}>
      <BrandLogo />
      <Flex direction="column">
        <EmptyState
          title=""
          subTitle={
            <Flex
              direction={'column'}
              justifyContent={'flex-start'}
              alignItems={'flex-start'}
              textAlign={'left'}
              gap={6}
            >
              <Box>
                <Text textStyle="headingTitle">Password Rest Link Sent</Text>
                <Text>
                  A password reset link has been sent to {email} and will expire
                  in 30 minutes. If you do not see it, check your spam folder or
                  confirm your email address. You can also request a new link.
                </Text>
              </Box>
              <Flex gap={3}>
                <Button
                  onClick={handleResendEmail}
                  disabled={forgetPasswordMutation.isLoading}
                >
                  Resend Email
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    navigate('/signup');
                  }}
                >
                  Back to Sign Up
                </Button>
              </Flex>
            </Flex>
          }
          bgColor="successSecondaryFill"
          icon={faCircleCheck}
          borderRadius={8}
        />
      </Flex>
    </Flex>
  );
};

export default PasswordResetInviteSent;
